import axiosIns from '@/plugins/axios'

export default {
  // 固定の分類ロール選択肢（key と日本語ラベル）を取得する
  getAggregationRoles() {
    return axiosIns.get('/v2/employee/user_management/aggregation_roles')
  },
}
